import Marquee from "react-fast-marquee";
import { decodeStyle, mobile, parseStyle, tablet } from "../../../juntion";
import { getContent, checkConditions } from "../../../junctionAbs";

function SlidingText({ id, db, dydb, gs, device }) {
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    const tabletStyle = tablet(device) ? ps.tablet : {};
    const mobileStyle = mobile(device) ? ps.mobile : {};

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    const content = getContent(dydb, input?.content);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Marquee
                play={true}
                gradient={false}
                speed={input.speed}
                direction={input.directionReverse ? "right" : "left"}
                pauseOnHover={input.pauseOnHover}
                pauseOnClick={input.pauseOnClick}
                delay={0}
                style={{
                    ...decodeStyle(ps.fixStyle, gs),
                    ...decodeStyle(ps.style, gs),
                    height: "100%",
                    // padding: "10px",
                    // backgroundColor: "cyan",
                    // color: "yellow",
                }}
            >
                <h3
                    style={{
                        fontSize: input.fontSize,
                        textTransform: input.uppercase ? "uppercase" : "none",
                        paddingRight: "20px",
                        fontWeight: input.bold ? "bold" : "normal",
                    }}
                >
                    {content}
                </h3>
            </Marquee>
        </div>
    );
}

export default SlidingText;
